import React from 'react';
import {VstInput} from 'vstui';

// Renders the Brytwave Activation Screen
class DecisionContainer extends React.Component {

  constructor() {
    super();
    this.state = { email: "" };

    this._checkEmailSubmit = this._checkEmailSubmit.bind(this);
    this._resetEmail = this._resetEmail.bind(this);
    this._onEmailChange = this._onEmailChange.bind(this);
  }

  componentDidUpdate() {
    // TODO :: Maybe we can bring this up a level?
    Fraction.Helpers.bindLinks();
  }

  _checkEmailSubmit(e) {
    if (this.props.isValidEmail(this.state.email) && !this.state.resent){
      Jigsaw.User.resendActivationEmail({
        email: this.state.email,
        url: `${window.location.origin}${window.location.search}`
      }, (response) => {
        if (response.isSuccess()){
          this.setState({emailSent: true, resent: this.state.emailSent});
        } else {
          this.setState({noActivationRequest: true});
        }
      });
    }
    e.preventDefault();
    return false;
  }

  _resetEmail(e) {
    this.setState({email: "", emailSent: false, resent: false, noActivationRequest: false});
  }

  _onEmailChange(e) {
    this.setState({email: e.currentTarget.value});
  }

  render() {
    return (
      <div>
        <div onScroll={this.props.redraw}>
          { Fraction.Helpers.modalToShow }

          <div className="account decision-container">

            {this.props.renderAccountGraphic()}

            <div className="account-content activation">
              <h1 className="large">
                {window.toHTML(i18n.t('signin.signin-welcome').decodeHTML())}
              </h1>
              <h1 className="small">
                {window.toHTML(i18n.t('signin.short-welcome').decodeHTML())}
              </h1>
              {!this.state.emailSent ?
                <div className="description">{window.toHTML(i18n.t('activation.invalid-link'))}</div> :
                <div className="description">{window.toHTML(i18n.t('activation.email-sent', {email: this.state.email}))}</div>
              }
              {this.state.noActivationRequest &&
                <span>
                  <div className="alert-description">{i18n.t('activation.no-activation-request')}</div>
                  <div className="alert-description">{window.toHTML(i18n.t('activation.change-email-or-support', {support: Fraction.Brand.Support.url}))}</div>
                </span>
              }
              {this.state.resent &&
                <div className="alert-description">{i18n.t('activation.activation-resent')}</div>
              }

              <form onSubmit={this._checkEmailSubmit} id="signin-form" method="post">
                <div className={"email-field"+(this.state.setEmail ? " set-email" : "")}>
                  {!this.state.emailSent &&
                    <VstInput id="email-field"
                              type="email"
                              label={i18n.t('base.email')}
                              options="large"
                              name="user[email]"
                              placeholder={i18n.t('base.email')}
                              value={this.state.email}
                              onChange={this._onEmailChange} />
                  }
                </div>
                {!this.state.resent && <VstInput type="submit" options="large" value={this.state.emailSent ? i18n.t('activation.resend-email') : i18n.t('base.continue')} />}
                {this.state.emailSent &&
                  <div className="decision-set-email">{window.toHTML(i18n.t('activation.not-email', {email: this.state.email}))} <span><a className="noButton" href="/#/activation" onClick={this._resetEmail}>{i18n.t('messages.go-back')}</a></span></div>
                }
              </form>

            </div>
          </div>
        </div>
      </div>
    );
  }

};

export default DecisionContainer;
